import { useParams, useSearchParams } from "react-router-dom";

import Action from "./Component/Action";
import Date from "./Component/Date";
import Dest from "./Component/Dest";
import { Grid, useTheme } from "@mui/material";
import Pagination from "components/Pagination";
import Prices from "./Component/Prices";
import Table from "components/Table";
import TableSkeleton from "components/Skeletons/Table.skeleton";
import TomanVal from "./Component/TomanVal";
import Type from "./Component/Type";
import UsdtVal from "./Component/UsdtVal";
import Wallet from "./Component/Wallet";
import { formatDateToJalali } from "utils/helpers/time";
import { getPortfolioTradeAvgForCoinList } from "store/slices/portfolio/portfolioSlice";
import useDispatch from "hooks/useDispatch";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const headers = [
  {
    name: "Action",
    key: "action",
    align: "left",
  },
  {
    name: "Src / Dst",
    key: "dest",
    align: "center",
  },
  {
    name: "Wallet",
    key: "wallet",
    align: "center",
  },
  {
    name: "Type",
    key: "type",
    align: "center",
  },
  {
    name: "Amount / Total Price",
    key: "prices",
    align: "center",
  },
  {
    name: "Date",
    key: "date",
    align: "center",
  },
  {
    name: "ٰValue of transaction time",
    key: "usdtVal",
    align: "center",
  },
  {
    name: "ٰValue of transaction time",
    key: "tomanVal",
    align: "center",
  },
];

function TablePortfolioTradeCoinList() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const theme = useTheme();

  const [searchParams] = useSearchParams();
  const startDate = searchParams.get("startDate") || "";
  const walletType = +searchParams.get("walletType") || 0;
  const portfolioDate = +searchParams.get("portfolioDate") || 0;

  const pageNumber = +searchParams.get("page") || 1;
  const pageSize = +searchParams.get("perPage") || 5;

  const portfolioSingleTradeList = useSelector(
    (state) => state.portfolio.portfolioSingleTradeList
  );

  useEffect(() => {
    dispatch(
      getPortfolioTradeAvgForCoinList({
        coinId: id,
        dateTypeId: portfolioDate,
        walletTypeId: walletType,
        pageNumber,
        pageSize,
        startDate: formatDateToJalali(startDate),
      })
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [walletType, portfolioDate, id, startDate, pageSize, pageNumber]);

  const formattedDataList = portfolioSingleTradeList?.data?.map((data) => {
    return {
      data: data,
      background:
        data?.side === "Buy"
          ? theme.palette.modules.colorRowTableBuy
          : theme.palette.modules.colorRowTableSell,
      action: <Action data={data} />,
      dest: <Dest data={data} />,
      wallet: <Wallet data={data} />,
      type: <Type data={data} />,
      prices: <Prices data={data} />,
      date: <Date data={data} />,
      usdtVal: <UsdtVal data={data} />,
      tomanVal: <TomanVal data={data} />,
      color:
        data?.side === "Buy"
          ? `${theme.palette.success.main}10`
          : `${theme.palette.error.main}10`,
    };
  });
  return (
    <Grid container>
      <Grid item xs={12} marginBottom={2}>
        {portfolioSingleTradeList?.data ? (
          <Table
            headers={headers}
            items={formattedDataList}
            hideBorders={true}
          />
        ) : (
          <TableSkeleton />
        )}
      </Grid>

      <Grid item xs={12}>
        <Pagination
          perPage={portfolioSingleTradeList?.pageSize}
          count={portfolioSingleTradeList?.totalPages}
          onChange={() => {}}
        />
      </Grid>
    </Grid>
  );
}

export default TablePortfolioTradeCoinList;
